export default __webpack_public_path__ + "static/media/Tutorial-Step-2.1.4fcbc932.jpg";